import { useToast } from '../app/toast';

export function Toasts() {
  const items = useToast((s) => s.items);
  const dismiss = useToast((s) => s.dismiss);
  return (
    <div aria-live="polite" className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex flex-col items-center gap-2 px-4 pt-[max(12px,env(safe-area-inset-top))]">
      {items.map((x) => (
        <button
          key={x.id}
          type="button"
          onClick={() => dismiss(x.id)}
          className={`pointer-events-auto w-full max-w-xl rounded-2xl px-4 py-3 text-left text-[16px] font-medium shadow-lg ${x.tone === 'bad' ? 'bg-bad text-white' : 'bg-acc text-acc-fg'}`}
        >
          {x.text}
        </button>
      ))}
    </div>
  );
}
